import $ from "jquery";
import "./../libraries/jquery.autocomplete";

var $win = null;
var $body = null;
var root = null;

$(document).ready(function () {
    // Globals
    $win = $(window);
    $body = $("body");
    root = $body.data("root");

    // Login
    positionLoginContainer();
    enableDynamicLoginForm();

    // Header
    alignCustomerBar();
    printWholeDocumentButton();

    $(modalPopupOnLaunch);
    $(myAccountNavigation);
    $(searchFormFocus);
    $(tableRowManipulation);
    $(rowExpandCollapseAll);
    $(rowLevelAlert);
    $("#holderClose").click(function () {
        $(lightboxClose);
    });
    $("#lightbox").click(function () {
        $(lightboxClose);
    });

    try {
        $(".tracking a").on("click", function (e) {
            e.stopPropagation();
        });
    } catch (err) {
        console.error(err);
    }

    /*! STATUS DEFAULT POSITION */
    var defaultStatusPosition = $("#status").css("top");

    $(hideZeroShipments);

    submitDropdownOnSelect("#customerSettings form");

    // Stock check page
    stockCheck();

    // Order pad page
    orderPad();
});

$(window).resize(function () {
    waitForFinalEvent(function () {
        positionLoginContainer();
        alignCustomerBar();
    }, 128);
});

$(window).scroll(function () {
    $(statusScroll);
    alignCustomerBar();
});

/**
 * Assign event to print button if it exists
 */
function printWholeDocumentButton() {
    // Check if button exists
    var $btn = $("#print-page-button");
    if ($btn.length) {
        // Assign click event
        $btn.click(function (e) {
            // Open print dialog
            window.print();

            // Prevent default
            e.preventDefault();
        });
    }
}

/**
 * Center login container on the screen
 */
function positionLoginContainer() {
    // Check if we're on login page
    if ($body.hasClass("login")) {
        // Get login container
        var $headerContainer = $("#header");
        var $contentContainer = $("#content .container");
        if (
            $headerContainer &&
            $headerContainer.length &&
            $contentContainer &&
            $contentContainer.length
        ) {
            // Reset height
            $contentContainer.css({ "min-height": "0px" });

            // Get window and container height
            var winHeight = $win.height();
            var hedHeight = $headerContainer.height();
            var conHeight = $contentContainer.height();

            // Calculate difference
            if (winHeight > conHeight + hedHeight) {
                $contentContainer.css({
                    "min-height": winHeight - hedHeight + "px",
                });
            }
        }
    }
}

/**
 * Set dynamic aspects of login form
 */
function enableDynamicLoginForm() {
    // Check if we're on login page
    if ($body.hasClass("login")) {
        $("#login-pick-region input").click(function (event) {
            var val = event.target.value;
            var $loginForm = $("#login-form");
            var $passwordForgotten = $("#password-forgotten-link");

            if ($loginForm) {
                if (val === "ca") {
                    $loginForm.attr(
                        "action",
                        $loginForm.attr("data-ca-action")
                    );
                } else if (val === "us") {
                    $loginForm.attr(
                        "action",
                        $loginForm.attr("data-us-action")
                    );
                }
            }

            if ($passwordForgotten) {
                if (val === "ca") {
                    $passwordForgotten.attr(
                        "href",
                        $passwordForgotten.attr("data-ca-url")
                    );
                } else if (val === "us") {
                    $passwordForgotten.attr(
                        "href",
                        $passwordForgotten.attr("data-us-url")
                    );
                }
            }
        });

        if ($loginForm) {
            var $submitButton = $("#login-form button[type=submit]")
            if ($submitButton) {
                if (typeof navigator !== 'undefined') {
                    if (navigator.cookieEnabled === false) {
                        $loginForm.addEventListener("submit", e => {
                            e.preventDefault()
                        })

                        $submitButton.outerHTML = `
                            <div style="block; width: 100%; padding-top: 16px; text-align: right;">
                                <p style="font-size: 0.875rem; color: #f0211F;">
                                    Cookies are required to use the Portal. <br />
                                    Please enable them and refresh the page to continue.
                                </p>
                            </div>
                        `;
                    }
                }
            }
        }
    }
}

function alignCustomerBar() {
    // Check if bar exists
    var $customerBar = $("#customer-bar");
    var $navigationBar = $("#navigation-bar");
    if ($customerBar.length && $navigationBar.length) {
        // Get scroll position
        var scrollTop = $win.scrollTop();

        // Get default position of customer bar
        var defaultTop =
            $navigationBar.outerHeight() + $navigationBar.offset().top;

        // For scroll bar below default fix bar to the top of the window
        if (scrollTop > defaultTop) {
            $customerBar.css({
                position: "fixed",
                left: "50%",
                "margin-left": -($customerBar.outerWidth() / 2),
            });
        }
        // Otherwise put bar in default position
        else {
            $customerBar.css({
                position: "relative",
                left: 0,
                "margin-left": "auto",
            });
        }
    }
}

/*! LOADING DATA FINISHED FUNCTION */
function actionDone() {
    $("#lightbox").fadeOut(300);
    $("#holderClose").delay(200).fadeOut(300);
    $("#additionalContent").delay(100).fadeOut(300);
    $("#additionalContent #holder").fadeOut(500);
    $("body").css("overflow", "auto");
}

/*! LIGHTBOX FUNCTION */
function lightbox() {
    $("#lightbox").fadeIn(300);
    $("#holderClose").delay(200).fadeIn(300);
    $("#additionalContent").delay(100).fadeIn(300);
    $("#additionalContent #holder").fadeIn(500);
    $("body").css("overflow", "hidden");
}

/*! MODAL ALERT POP-UP */
function modalPopupOnLaunch() {
    if ($(".modalAlert .per100").length > 0) {
        $(lightbox);
        $("#additionalContent .dataHolder:eq(1)").hide();
    } else {
        $("#additionalContent .dataHolder:eq(0)").hide();
    }
}

/*! MY ACCOUNT NAVIGATION */
function myAccountNavigation() {
    $("#subNavigation #myAccountHidden a").not("#myAccount").hide();
    $("#subNavigation #myAccountHidden").hover(
        function () {
            $("#myAccountHidden a").not("#myAccount").stop(true, true).fadeIn();
        },
        function () {
            $("#myAccountHidden a")
                .not("#myAccount")
                .stop(true, true)
                .fadeOut();
        }
    );
}

/*! SEARCH FORM FOCUS */
function searchFormFocus() {
    $("#footer .searchLink").click(function (event) {
        $("#searchForm #searchFormField").focus();
        event.preventDefault();
    });

    var defaultInputValue = $("#searchFormField").val();
    $("#searchFormField").css({ width: "90px" });
    $("#searchForm #searchFormField").focus(function () {
        if ($(this).val() === defaultInputValue) {
            $(this).val("");
        }
        $(this).animate(
            {
                width: "200px",
            },
            500
        );
    });
    $("#searchForm #searchFormField").focusout(function () {
        if ($(this).val() === "") {
            $(this).val(defaultInputValue);
        }
        $(this).delay(300).animate(
            {
                width: "90px",
            },
            300
        );
        $(this).siblings("#searchFormButton").removeClass("clear");
    });
    $("#searchFormField").keyup(function () {
        $(this).siblings("#searchFormButton").addClass("clear");
    });
    /*! SEARCH FORM CLICK
     $('#searchFormButton').click(function () {
     return false;
     });
     */
}

/* TABLE ROW MANIPULATION */
function tableRowManipulation() {
    /*! TABLE ROW CLICK ACTION */
    $("tr.basicData.expandable").click(function () {
        // Get clicked row
        var $basicRow = $(this);
        var $nextRow = $basicRow.next();
        var $nextRowDataHolder = $nextRow.find(".dataHolder");
        var $shipmentsRow = $nextRow.next(".shipmentsData");
        var $shipmentsRowDataHolder = $shipmentsRow.length
            ? $shipmentsRow.find(".dataHolder")
            : null;

        // Action to happen when additional data is open
        if ($basicRow.hasClass("open")) {
            $nextRowDataHolder.hide();
            $nextRow.hide();

            $basicRow.removeClass("open");

            // Action to check if shipments are open
            if ($shipmentsRowDataHolder !== null) {
                $shipmentsRowDataHolder.hide();
                $shipmentsRow.hide();

                if ($shipmentsRow.css("display") === "table-row") {
                    // Get show more button
                    var $showMorebutton = $nextRow.find(".showMore");

                    // Reference labels
                    var showMoreStoredLabel = "";
                    var showMoreCurrentLabel = "";

                    // Copy labels
                    showMoreStoredLabel =
                        $showMorebutton.attr("data-toggle-label");
                    showMoreCurrentLabel = $showMorebutton.text();

                    // Change label
                    $showMorebutton.attr(
                        "data-toggle-label",
                        showMoreCurrentLabel
                    );
                    $showMorebutton.text(showMoreStoredLabel);

                    // Change button's style
                    $showMorebutton.removeClass("button-cancel");
                    $showMorebutton.addClass("button-secondary");
                }
            }

            // Action to happen when additional data is closed
        } else {
            $nextRow.show();
            $nextRowDataHolder.show();

            var $nextRowActions = $nextRowDataHolder.find(".row-level-actions");
            if ($nextRowActions.length && !$nextRowActions.hasClass("bound")) {
                // Add bound class
                $nextRowActions.addClass("bound");

                // Assign print row event
                var $printButton = $nextRowActions.find(".print");
                if ($printButton.length) {
                    $printButton.click(function (e) {
                        // Open shipments row if it exists
                        $nextRow
                            .nextUntil("tr.basicData")
                            .addClass("open")
                            .show()
                            .find(".dataHolder")
                            .show();

                        // Get root uri
                        var root = $body.data("root");

                        // Create print document
                        var print = "";

                        // Html structure
                        print += "<html>";

                        // Head structure
                        print += "<head>";
                        print += "<title></title>"; // TODO: Assign title
                        print +=
                            '<link rel="stylesheet" type="text/css" media="all" href="' +
                            root +
                            '/rediportal/css/app.css">';
                        print +=
                            '<link rel="stylesheet" type="text/css" media="print" href="' +
                            root +
                            '/rediportal/css/print.css">';
                        print += "</head>";

                        // Body structure
                        print += "<body>";

                        // Basic table
                        print += '<table class="items">';
                        print += $basicRow
                            .closest("table.items")
                            .find("thead.basic-head")
                            .html();
                        print += "<tbody>";
                        print += $basicRow.html();
                        print += "</tbody>";
                        print += "</table>";

                        // Additional table if exists
                        var $nextRowDataHolderTable =
                            $nextRowDataHolder.find("table");
                        if ($nextRowDataHolderTable.length) {
                            print +=
                                '<div class="dataHolder dataHolderStandalone">';
                            print += $nextRowDataHolder.html();
                            print += "</div>";
                        }

                        // Shipments table if it exists
                        if ($shipmentsRowDataHolder !== null) {
                            print +=
                                '<div class="dataHolder dataHolderStandalone">';
                            print += $shipmentsRowDataHolder.html();
                            print += "</div>";
                        }

                        print += "</body>";

                        print += "</html>";

                        // Open window
                        var printWindow = window.open();
                        printWindow.document.write(print);
                        setTimeout(function () {
                            printWindow.print();
                        }, 1024);

                        // Prevent default
                        e.preventDefault();
                    });
                }
            }

            $basicRow.addClass("open");
        }
    });

    /*! SHOW MORE SHIPMENTS BUTTON EVENT */
    $(".showMore").click(function () {
        // Reference
        var showMoreStoredLabel = "";
        var showMoreCurrentLabel = "";

        // Action to happen when shipments are closed
        if (!$(this).parents("tr").hasClass("open")) {
            // Show next shipments row
            if (
                !(
                    $.browser.msie &&
                    parseInt($.browser.version.substr(0, 1), 10) < 9
                )
            ) {
                $(this)
                    .parents("tr")
                    .addClass("open")
                    .nextUntil("tr.basicData, .noResults")
                    .show()
                    .find(".dataHolder")
                    .show()
                    .css({
                        opacity: "0",
                    })
                    .animate(
                        {
                            opacity: "1",
                        },
                        500
                    );
            } else {
                $(this)
                    .parents("tr")
                    .addClass("open")
                    .nextUntil("tr.basicData, .noResults")
                    .show()
                    .find(".dataHolder")
                    .show();
            }

            // Copy labels
            showMoreStoredLabel = $(this).attr("data-toggle-label");
            showMoreCurrentLabel = $(this).text();

            // Change label
            $(this).attr("data-toggle-label", showMoreCurrentLabel);
            $(this).text(showMoreStoredLabel);

            // Change button's style
            $(this).removeClass("button-secondary");
            $(this).addClass("button-cancel");

            // Action to happen when shipments are open
        } else {
            // Hide next shipments row
            if (
                !(
                    $.browser.msie &&
                    parseInt($.browser.version.substr(0, 1), 10) < 9
                )
            ) {
                $(this)
                    .parents("tr")
                    .removeClass("open")
                    .nextUntil("tr.basicData, .noResults")
                    .find(".dataHolder")
                    .fadeOut(300, function () {
                        $(this).parents("tr.shipmentsData").hide();
                    });
            } else {
                $(this)
                    .parents("tr")
                    .removeClass("open")
                    .nextUntil("tr.basicData, .noResults")
                    .find(".dataHolder")
                    .hide()
                    .parents("tr.shipmentsData")
                    .hide();
            }

            // Copy labels
            showMoreStoredLabel = $(this).attr("data-toggle-label");
            showMoreCurrentLabel = $(this).text();

            // Change label
            $(this).attr("data-toggle-label", showMoreCurrentLabel);
            $(this).text(showMoreStoredLabel);

            // Change button's style
            $(this).removeClass("button-cancel");
            $(this).addClass("button-secondary");
        }

        // Return
        return false;
    });
}

/**
 * Removes all elements used for autocomplete search feedback
 *
 * @param {HTMLElement} searchForm (search form element)
 */
function removeAllAutocompleteSeachFeedback(searchForm) {
    $(searchForm).find(".autocomplete-nothing-found").remove();
    $(searchForm).find(".spinner").remove();
    $(searchForm).find(".autocomplete-error").remove();
}

/**
 * Expand or collapse all rows
 */
function rowExpandCollapseAll() {
    /*! ROW MANIPULATION BUTTONS CLICK */
    $("#rowManipulation a").click(function () {
        var thisClick = $(this);
        var count = $("tr").length;

        $("#lightbox").fadeIn(400, function () {
            if (thisClick.hasClass("expandAll")) {
                $("tr.basicData.expandable").addClass("open").show();
                $("tr.additionalData").show().find(".dataHolder").show();
                $("tr").each(function () {
                    if (!--count) {
                        $(actionDone);
                    }
                });
            }

            if (thisClick.hasClass("collapseAll")) {
                $("tr.basicData.expandable").removeClass("open").show();
                $("tr.additionalData")
                    .removeClass("open")
                    .hide()
                    .find(".dataHolder")
                    .hide()
                    .find(".showMore")
                    .removeClass("open")
                    .find("img")
                    .attr("src", "images/shipments.png");
                $("tr.shipmentsData").hide().find(".dataHolder").hide();
                $("tr").each(function () {
                    if (!--count) {
                        $(actionDone);
                    }
                });
            }
        });

        //return false;
    });
}

/*! LIGHTBOX MORE DATA CLOSE */
function lightboxClose() {
    $("#holderClose").fadeOut(300);
    $("#lightbox").fadeOut(300);
    $("#additionalContent").delay(100).fadeOut(300);
    $("#additionalContent #holder").fadeOut(300);
    $("body").css("overflow", "auto");
}

/*! STATUS SCROLL */
function statusScroll() {
    $("#status").css({
        position: "absolute",
    });
    var windowScroll = $(window).scrollTop();
    if (windowScroll < 155) {
        $("#status").stop(true, true).delay(300).animate(
            {
                top: "155px",
            },
            500
        );
    } else {
        $("#status")
            .stop(true, true)
            .delay(300)
            .animate(
                {
                    top: windowScroll + 55 + "px",
                },
                500
            );
    }
}

/*! ROW LEVEL ALERT */
function rowLevelAlert() {
    function rowAlert() {
        /*! TABLE ROW ALERT HOVER */
        $('<div id="alertMessage"></div>').appendTo("body");
        $("td.alert").hover(
            function () {
                var alertMessage = $(this).parent("tr").attr("data-Alert");
                var thisPos = $(this).offset();
                var thisW = $(this).outerWidth();
                var alertH = $("#alertMessage").outerHeight();
                $("#alertMessage")
                    .text(alertMessage)
                    .css({
                        left: thisPos.left + thisW + 20,
                        top: thisPos.top - alertH / 2,
                        position: "absolute",
                    })
                    .stop(false, false)
                    .show()
                    .fadeTo(300, 1.0);
            },
            function () {
                $("#alertMessage").fadeOut(300);
            }
        );
        $("td.alert").click(function () {
            var alertMessage = $(this).parent("tr").attr("data-Alert");
            var thisPos = $(this).offset();
            var thisW = $(this).outerWidth();
            var alertH = $("#alertMessage").outerHeight();
            $("#alertMessage")
                .text(alertMessage)
                .css({
                    left: thisPos.left + thisW + 20,
                    top: thisPos.top - alertH / 2,
                    position: "absolute",
                })
                .stop(false, false)
                .show()
                .fadeTo(300, 1.0);
            $("td.alert").removeClass("visible");
            $(this).addClass("visible");
        });
        $("td.alert.visible").click(function () {
            $(this).removeClass("visible");
            $("#alertMessage").fadeOut(300);
        });
    }

    $(".basicData").each(function () {
        if ($(this).attr("data-Alert")) {
            $(this).find("td").first().addClass("alert");
        }
    });
    rowAlert();
}

function submitDropdownOnSelect(form) {
    var item = $(form);
    item.find("select").change(function () {
        $(this).closest("form").submit();
    });
}

function hideZeroShipments() {
    $(".numbernotzero").each(function () {
        if ($(this).text() === "0.00") {
            $(this).parent().remove();
        }
    });
}

function stockCheck() {
    // Get stock check container
    var $stockCheck = $("#stock-search");
    if ($stockCheck && $stockCheck.length) {
        // Get stock buttons
        var $clearButton = $("#clear-selected-item");

        // Get stock check form and fields
        var $stockCheckForm = $stockCheck.find("form#stock-search-form");
        var $stockCheckItemsField = $stockCheckForm.find(
            "#stock-selected-items"
        );
        var $stockCheckItemsDataField = $stockCheckForm.find(
            "#stock-selected-items-data"
        );
        var $stockCheckSearchByFairviewPartNo = $stockCheck.find(
            "#stock-search-field"
        );
        var $stockCheckSearchByCustomerPartNo = $stockCheck.find(
            "#stock-search-field-by-customer-part-no"
        );

        // Select search field
        $stockCheckSearchByFairviewPartNo.focus();

        // Get current items
        var stockCheckItemsFieldValue = $stockCheckItemsField
            .val()
            .replace(/'/g, '"');
        var stockCheckItemsDataFieldValue = $stockCheckItemsDataField
            .val()
            .replace(/'/g, '"');
        var currentStockItems =
            stockCheckItemsFieldValue === ""
                ? []
                : JSON.parse(stockCheckItemsFieldValue);
        var currentStockItemsData =
            stockCheckItemsDataFieldValue === ""
                ? []
                : JSON.parse(stockCheckItemsDataFieldValue);

        // Get items list
        var $itemsTableBody = $("#stock-items-list");
        if ($itemsTableBody && $itemsTableBody.length) {
            $itemsTableBody.find("tr").each(function (index, value) {
                // Get row and its index
                var $row = $(this);
                var rowIndex = $row.index();

                // Get remove button and assign click event if it exists
                var $remove = $row.find("td.item-remove a");
                if ($remove && $remove.length) {
                    $remove.on("click", function (e) {
                        // Remove item from data arrays
                        currentStockItems.splice(rowIndex, 1);
                        currentStockItemsData.splice(rowIndex, 1);

                        // Put stringified json into form
                        $stockCheckItemsField.val(
                            JSON.stringify(currentStockItems)
                        );
                        $stockCheckItemsDataField.val(
                            JSON.stringify(currentStockItemsData)
                        );

                        // Submit form and refresh page
                        $stockCheckForm.submit();

                        // Prevent default
                        e.preventDefault();
                    });
                }
            });
        }

        // Language
        var langNoResults = $stockCheckForm.data("noresults");

        // Autocomplete options
        var autocompleteOptions = {
            serviceUrl: root,
            params: { noprice: 'true' },
            deferRequestBy: 256,
            minChars: 3,
            autoSelectFirst: true,
            showNoSuggestionNotice: true,
            noSuggestionNotice: langNoResults,
            onSearchStart: function () {
                removeAllAutocompleteSeachFeedback($(this).parent().get(0));
                if ($(this).parent().find(".spinner").length === 0) {
                    $(this)
                        .parent()
                        .append(
                            '<svg class="spinner" width="16px" height="16px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle></svg>'
                        );
                }
            },
            onSearchComplete: function (query, suggestions) {
                var _parent = $(this).parent();
                setTimeout(function () {
                    $(_parent).find(".spinner").remove();
                }, 1024);
            },
            onError: function () {
                $(this)
                    .parent()
                    .append(
                        '<span class="autocomplete-error">Try again.</span>'
                    );
            },
            onSelect: function (suggestion) {
                removeAllAutocompleteSeachFeedback($(this).parent().get(0));
                // Get item data
                var data = suggestion.data;
                var itemCode = data.itemcode;
                var itemInStock = data.localstock;
                var itemPotential = data.nationalstock;

                // Add item to current stock check items array
                currentStockItems.push(itemCode);
                $stockCheckItemsField.val(JSON.stringify(currentStockItems));

                // Add item data to current stock check items data array
                currentStockItemsData.push(data);
                $stockCheckItemsDataField.val(
                    JSON.stringify(currentStockItemsData)
                );

                // Submit form
                $stockCheckForm.submit();
            },
        };

        // Autocomplete for stock check search by fairview part no
        autocompleteOptions.serviceUrl = root + "/api/item/stock-check.php";

        $stockCheckSearchByFairviewPartNo.autocomplete(autocompleteOptions);

        // Autocomplete for stock check search by customer part no
        autocompleteOptions.serviceUrl =
            root + "/api/item/search-by-customer-part-no.php";

        $stockCheckSearchByCustomerPartNo.autocomplete(autocompleteOptions);

        // Clear items button event
        $clearButton.on("click", function (e) {
            $stockCheckItemsField.val("");
            $stockCheckItemsDataField.val("");
            $stockCheckForm.submit();
            e.preventDefault();
        });
    }
}

function orderPad() {
    // Items in cart
    var minOrderPrice = 0;
    var itemsInCart = [];
    var $orderPadItemsTable = null;

    // Info fields
    var $deliveryMethodRadios = null;
    var $shippingAddressDropdown = null;
    var $infoFieldPoNum = null;
    var $infoFieldShipViaAcctNo = null;
    var $infoFieldConfirmationEmail = null;
    var $infoFieldOrderNote = null;
    var $orderpadHeaderNotice = null;

    // Add ability to hide the notice
    $orderpadHeaderNotice = $("#orderpad-header-notice");
    if ($orderpadHeaderNotice) {
        $orderpadHeaderNotice.append(
            '<a href="#hide-notice">X<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24" xml:space="preserve"><polygon fill="#FFFFFF" points="17.303,7.404 16.596,6.697 12,11.293 7.404,6.697 6.697,7.404 11.293,12 6.697,16.596 7.404,17.303 12,12.707 16.596,17.303 17.303,16.596 12.707,12 "></polygon></svg></a>'
        );

        var $orderpadHeaderNoticeHideButton = $orderpadHeaderNotice.find("a");
        if ($orderpadHeaderNoticeHideButton) {
            $orderpadHeaderNoticeHideButton.on("click", function (e) {
                e.preventDefault();
                $orderpadHeaderNotice.hide();
            });
        }
    }

    // Show total order price
    function orderPadCartTotalPrice() {
        // Total
        var total = 0;

        // Iterate through rows
        $orderPadItemsTable.find("tr.item-row").each(function () {
            // Get row data
            var $row = $(this);
            var $input = $row.find(
                "td.item-quantity input.item-quantity-value"
            );
            var inputVal = $input.val();
            var quantity = inputVal.length > 0 ? parseInt(inputVal) : 1;
            var price = parseFloat($input.data("price"));

            // Count row line total
            var lineTotal = quantity * price;

            // $total.html((price * newValue).parseAsCurrency(parseAsCurrencyWrap, parseAsCurrencyCode));
            // Add to main
            total += lineTotal;
        });

        // Displayed parsed total
        $("#order-status-total").html(total.parseAsCurrency(false));

        return total;
    }

    // Get items from the cart
    function orderPadCartGetItems() {
        // Call the API
        $.ajax({
            url: root + "/api/cart/get.php",
            type: "GET",
        }).done(function (json) {
            // Check if result is successful
            if (json.status === 1) {
                // Get customer info
                minOrderPrice =
                    json.data.customer &&
                    typeof json.data.customer.minorder === "number"
                        ? json.data.customer.minorder
                        : null;

                // Iterate through items
                var items = json.data.item;
                for (var itemKey in items) {
                    if (items.hasOwnProperty(itemKey)) {
                        // Current item
                        var item = items[itemKey];
                        orderPadCartAddItem(
                            item.itemcode,
                            item.customer_item_code,
                            item.itemname,
                            item.minorder || 1,
                            item.multiply || 1,
                            item.price,
                            item.localstock,
                            item.nationalstock,
                            item.quantity,
                            minOrderPrice
                        );
                    }
                }

                // Get additional info
                var info = json.data.info;

                // Define shipping type codes
                var shippingCodes = [
                    "8",
                    "15",
                    "16",
                    "17",
                    "18",
                    "19",
                    "20",
                    "21",
                    "42",
                    "47",
                    "48",
                    "49",
                    "50",
                    "51",
                    "52",
                ];

                // Check the appropriate radio button
                if (shippingCodes.indexOf(info.shipping) !== -1) {
                    $("#r-shipping").prop("checked", true);
                } else {
                    $("#r-pickup").prop("checked", true);
                }

                // Check if delivery method has been selected
                if (
                    typeof info.shipping !== "undefined" &&
                    info.shipping !== null
                ) {
                    $deliveryMethodRadios.each(function () {
                        var $radio = $(this);
                        if ($radio.val() === info.shipping) {
                            $radio.prop("checked", true);
                        }
                    });
                }

                // Check if address has been selected
                if (
                    typeof info.address_id !== "undefined" &&
                    info.address_id !== null
                ) {
                    $shippingAddressDropdown.val(info.address_id);
                }

                // Check if po number has been inserted
                if (typeof info.po !== "undefined" && info.po !== null) {
                    $infoFieldPoNum.val(info.po);
                }

                // if (typeof info.po !== "undefined" && info.po !== null) {
                //     $infoFieldPoNum.val(info.po);
                // }

                // Check if order notes has been inserted
                if (typeof info.notes !== "undefined" && info.notes !== null) {
                    $infoFieldOrderNote.val(info.notes);
                }

                handleHelpRow();
            }
        });
    }

    // Add item to the cart
    function orderPadCartAddItem(
        itemCode,
        customerItemCode,
        itemName,
        itemMinOrder,
        itemMultiple,
        itemPrice,
        localStock,
        nationalStock,
        quantityInCart,
        customerMinOrder
    ) {
        // Determine minimum quantity of the item
        var minimumQuantity = itemMinOrder || 1;
        var multipleOfQuantity = itemMultiple || 1;

        quantityInCart = (quantityInCart || 1) > minimumQuantity
            ? quantityInCart || 1
            : minimumQuantity

        var quantityMod = quantityInCart % multipleOfQuantity
        if (quantityMod > 0) {
            quantityInCart = quantityInCart + (multipleOfQuantity - quantityMod)
        }

        // Check if item is already in cart
        var $item = $("#item-" + itemCode.replace(/\W+/g, "--"));
        if ($item.length) {
            // Highlight row if it already exists
            $item.addClass("highlight");
            setTimeout(function () {
                $item.removeClass("highlight");
            }, 2048);
        }
        // Otherwise add item to table and cart
        else {
            // Submit and save change to database
            orderPadcartChangeItem(itemCode, quantityInCart);
            itemsInCart.push(itemCode);

            // Parse data
            var parsedQuantity = parseInt(quantityInCart);
            var parsedPrice = parseFloat(itemPrice);

            // Parse price as currency
            var parseAsCurrencyWrap = true;
            var parseAsCurrencyCode = "USD";

            // Create item structure
            $item = $(
                '<tr class="basicData item-row fadeInUp animated" id="item-' +
                    itemCode.replace(/\W+/g, "--") +
                    '" />'
            );

            $item.append(
                $('<td class="text-left item-code text">' + itemCode + "</td>")
            );

            // If item description is more than 24 characters trim it
            if (itemName.length > 24) {
                $item.append(
                    $(
                        '<td class="text-left item-name text"><span title="' +
                            itemName +
                            '">' +
                            itemName.slice(0, 24) +
                            "...</span></td>"
                    )
                );
            } else {
                $item.append(
                    $(
                        '<td class="text-left item-name text"><span >' +
                            itemName +
                            "</span></td>"
                    )
                );
            }

            $item.append(
                $(
                    '<td class="text-left item-code text">' +
                        (customerItemCode !== null ? customerItemCode : "") +
                        "</td>"
                )
            );

            $item.append(
                $(
                    '<td class="text-center item-local-stock">' +
                        localStock +
                        "</td>"
                )
            );

            $item.append(
                $(
                    '<td class="text-center item-national-stock">' +
                        nationalStock +
                        "</td>"
                )
            );

            $item.append(
                $(
                    '<td class="text-left item-price price">' +
                        parsedPrice.parseAsCurrency(
                            parseAsCurrencyWrap,
                            parseAsCurrencyCode,
                            "TBD"
                        ) +
                        "</td>"
                )
            );

            var qtyFields = '';

            // Decrease
            qtyFields += '<a href="#-" class="item-quantity-decrease">-<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 26 40" xml:space="preserve"><rect x="8.0" y="19.5" width="10" height="1"></rect></svg></a>'

            // Field
            qtyFields += '<div>'

            qtyFields += '<input '
                qtyFields += 'class="text-center item-quantity-value" '
                qtyFields += 'tabindex="1" '
                qtyFields += 'type="number" '
                qtyFields += 'required="true" '
                qtyFields += 'value="' + quantityInCart + '" '
                qtyFields += 'min="' + (minimumQuantity || 1) + '" '
                qtyFields += 'step="' + (multipleOfQuantity || 1) + '" '
            qtyFields += '>'

            if (minimumQuantity > 1 || multipleOfQuantity > 1) {
                qtyFields += '<p>'

                if (minimumQuantity > 1) {
                    qtyFields += 'Minimum of : <strong>' + minimumQuantity + '</strong>'
                }

                if (multipleOfQuantity > 1) {
                    qtyFields += minimumQuantity > 1 ? '&nbsp;&nbsp;&nbsp;' : '';
                    qtyFields += 'Multiple of: <strong>' + multipleOfQuantity + '</strong>'
                }

                qtyFields += '</p>'
            }

            qtyFields += '</div>'

            // Increase
            qtyFields += '<a href="#+" class="item-quantity-increase">+<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 26 40" xml:space="preserve"><rect x="8.0" y="19.5" width="10" height="1"></rect><rect x="12.5" y="15.0" width="1" height="10"></rect></svg></a>'

            $item.append($('<td class="text-center item-quantity quantity">' + qtyFields + '</td>'));

            $item.append(
                $(
                    '<td class="text-right line-total">' +
                        (parsedQuantity * parsedPrice).parseAsCurrency(
                            parseAsCurrencyWrap,
                            parseAsCurrencyCode,
                            "TBD"
                        ) +
                        "</td>"
                )
            );
            $item.append(
                $(
                    '<td class="text-center item-remove" title="Remove Item"><a href="#remove">X<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24" xml:space="preserve"><polygon fill="#FFFFFF" points="17.303,7.404 16.596,6.697 12,11.293 7.404,6.697 6.697,7.404 11.293,12 6.697,16.596 7.404,17.303 12,12.707 16.596,17.303 17.303,16.596 12.707,12 "></polygon></svg></a> </td>'
                )
            );

            // Buttons
            var $increase = $item.find(
                "td.item-quantity a.item-quantity-increase"
            );
            var $decrease = $item.find(
                "td.item-quantity a.item-quantity-decrease"
            );
            var $input = $item.find(
                "td.item-quantity input.item-quantity-value"
            );
            var $total = $item.find("td.line-total");
            var $remove = $item.find("td.item-remove a");

            // Add price to input
            $input.data("price", itemPrice);
            $input.val(quantityInCart);

            // Create increase button event
            $increase.on("click", function (e) {
                // Update value
                var currentValue = parseInt($input.val());
                var newValue = currentValue + multipleOfQuantity;
                $input.val(newValue);

                // Update line total price
                var price = parseFloat($input.data("price"));
                $total.html(
                    (price * newValue).parseAsCurrency(
                        parseAsCurrencyWrap,
                        parseAsCurrencyCode
                    )
                );

                // Wait for final event
                waitForFinalEvent(function () {
                    // Update quantity in cart
                    orderPadcartChangeItem(itemCode, parseInt($input.val()));
                }, 512);

                // Prevent default
                e.preventDefault();
            });

            // Create decrease button event
            $decrease.on("click", function (e) {
                // Update value
                var currentValue = parseInt($input.val());
                var newValue =
                    currentValue > minimumQuantity
                        ? currentValue - multipleOfQuantity
                        : minimumQuantity;

                $input.val(newValue);

                // Update line total price
                var price = parseFloat($input.data("price"));
                $total.html(
                    // @ts-ignore
                    (price * newValue).parseAsCurrency(
                        parseAsCurrencyWrap,
                        parseAsCurrencyCode
                    )
                );

                // Wait for final event
                waitForFinalEvent(function () {
                    // Update quantity in cart
                    orderPadcartChangeItem(itemCode, parseInt($input.val()));
                }, 512);

                // Prevent default
                e.preventDefault();
            });

            // Create direct quantity field change event
            $input.on("keyup", function (e) {
                // Wait for final event
                waitForFinalEvent(function () {
                    var newValue = null;

                    // Check value length
                    if ($input.val().length < 1) {
                        // Continue count with minimal value
                        newValue = 1;

                        // Wait before you fill empty fill to improve user experience
                        setTimeout(function () {
                            if ($input.val().length < 1) {
                                $input.val(minimumQuantity);
                            }
                        }, 5120);
                    } else {
                        // Update value
                        newValue = parseInt($input.val());

                        // Check if it's NaN or not
                        if (isNaN(newValue)) {
                            newValue = minimumQuantity;
                        }

                        // Check if value is lower than minimum
                        if (newValue < minimumQuantity) {
                            newValue = minimumQuantity;
                        }

                        // Insert new value
                        $input.val(newValue);
                    }

                    // Update line total price
                    var price = parseFloat($input.data("price"));
                    $total.html(
                        (price * newValue).parseAsCurrency(
                            parseAsCurrencyWrap,
                            parseAsCurrencyCode
                        )
                    );

                    // Update quantity in cart
                    orderPadcartChangeItem(itemCode, newValue);
                }, 512);
            });

            // Create blur event that checks for min quantity and multiple of
            $input.on("blur", function (e) {
                var newValue = null
                var isChanged = false

                if ($input.val().trim().length < 1) {
                    $input.val(minimumQuantity)
                } else {
                    // Update value
                    newValue = parseInt($input.val());

                    // Check if it's NaN or not
                    if (isNaN(newValue)) {
                        newValue = minimumQuantity;
                        isChanged = true;
                    }

                    // Check if value is multiple of
                    var remain = newValue % multipleOfQuantity;
                    if (remain > 0) {
                        newValue = newValue + (multipleOfQuantity - remain);
                        isChanged = true;
                    }

                    // Check if value is lower than minimum
                    if (newValue < minimumQuantity) {
                        newValue = minimumQuantity;
                        isChanged = true;
                    }

                    // Insert new value
                    $input.val(newValue);

                    // Update line total price
                    var price = parseFloat($input.data("price"));
                    $total.html(
                        (price * newValue).parseAsCurrency(
                            parseAsCurrencyWrap,
                            parseAsCurrencyCode
                        )
                    );

                    // Update quantity in cart
                    if (isChanged) {
                        orderPadcartChangeItem(itemCode, newValue);
                    }
                }
            })

            // Create remove event
            $remove.on("click", function (e) {
                // Remove from database
                orderPadCartDeleteItem(itemCode);

                // Prevent default
                e.preventDefault();
            });

            // Add item to DOM
            $orderPadItemsTable.prepend($item);

            // Move total row to the end
            $orderPadItemsTable.append($("#order-summary"));

            // Remove row with help text
            handleHelpRow();

            // Count new total
            orderPadCartTotalPrice();
        }
    }

    // Remove item from cart
    function orderPadCartDeleteItem(itemCode) {
        // Remove item from items in cart object
        var i = itemsInCart.indexOf(itemCode);
        // itemsInCart.splice(i, 1);

        // Remove item from cart table
        var $itemRow = $("#item-" + itemCode.replace(/\W+/g, "--"));
        if ($itemRow.length) {
            $itemRow.addClass("fadeOutDown");

            // Remove the element after the animations ends
            setTimeout(function () {
                $itemRow.remove();
                handleHelpRow();

                // Count new total
                orderPadCartTotalPrice();
            }, 512);
        }

        // Send request to remove item from cart
        $.ajax({
            url: root + "/api/cart/delete.php",
            type: "POST",
            data: "itemcode=" + itemCode,
        });

        // Count new total
        orderPadCartTotalPrice();
    }

    // Clean order pad
    function orderPadCartCleanup() {
        // Clear info fields
        $infoFieldPoNum.val("");
        $infoFieldOrderNote.val("");

        // Remove all items from cart
        orderPadCartDeleteAllItems();
    }

    // Remove all items from cart
    function orderPadCartDeleteAllItems() {
        // Iterate through items in cart
        for (var i = 0; i < itemsInCart.length; i++) {
            var itemCode = itemsInCart[i];
            orderPadCartDeleteItem(itemCode);
        }
    }

    // Change item quantity in cart
    function orderPadcartChangeItem(itemCode, quantity) {
        // Get info field values
        var shippingAddressId = $("#shipping-address").val();
        var orderPoNum = $("#po-num").val();
        var orderNotes = $("#special-instructions").val();

        // Prepare output
        var request = "itemcode=" + itemCode;
        request += "&quantity=" + quantity;
        request += "&address_id=" + shippingAddressId;
        request += "&po=" + orderPoNum;
        request += "&notes=" + orderNotes;

        // Send request
        $.ajax({
            url: root + "/api/cart/add.php",
            type: "POST",
            data: request,
        }).done(function (json) {
            var price = parseFloat(json.data.item.price);
            var $input = $("#item-" + itemCode.replace(/\W+/g, "--")).find(
                "input.item-quantity-value"
            );
            var $priceArea = $("#item-" + itemCode.replace(/\W+/g, "--")).find(
                ".item-price"
            );
            var $lineTotalArea = $(
                "#item-" + itemCode.replace(/\W+/g, "--")
            ).find(".line-total");
            $input.data("price", price);
            var parseAsCurrencyWrap = true;
            var parseAsCurrencyCode = "USD";

            $priceArea.html(
                price.parseAsCurrency(parseAsCurrencyWrap, parseAsCurrencyCode)
            );
            $lineTotalArea.html(
                (price * quantity).parseAsCurrency(
                    parseAsCurrencyWrap,
                    parseAsCurrencyCode
                )
            );

            // Count new total
            orderPadCartTotalPrice();
        });
    }

    // Get order pad's search container
    var $orderPadSearch = $("#orderpad-search");
    if ($orderPadSearch && $orderPadSearch.length) {
        // Order pad search form
        var $orderPadSearchForm = $orderPadSearch.find("#orderpad-search-form");
        var $orderPadSearchField = $orderPadSearchForm.find(
            "#orderpad-search-field"
        );
        var $orderPadSearchFieldByCustomerPartNo = $orderPadSearchForm.find(
            "#orderpad-search-field-by-customer-part-no"
        );

        // Focus on the field when page loads
        $orderPadSearchField.focus();

        // Search form submit event
        $orderPadSearchForm.on("submit", function (e) {
            e.preventDefault();
        });

        // Autocomplete options
        var autocompleteOptions = {
            serviceUrl: root,
            deferRequestBy: 256,
            minChars: 2,
            autoSelectFirst: true,
            onSearchStart: function () {
                removeAllAutocompleteSeachFeedback($(this).parent().get(0));

                if ($(this).parent().find(".spinner").length === 0) {
                    $(this)
                        .parent()
                        .append(
                            '<svg class="spinner" width="16px" height="16px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"> <circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle></svg>'
                        );
                }
            },
            onSearchComplete: function (query, suggestions) {
                var _parent = $(this).parent();
                setTimeout(function () {
                    $(_parent).find(".spinner").remove();
                }, 1024);
            },
            onError: function () {
                $(this)
                    .parent()
                    .append(
                        '<span class="autocomplete-error">Try again.</span>'
                    );
            },
            onSelect: function (suggestion) {
                // remove help text elements
                removeAllAutocompleteSeachFeedback($(this).parent().get(0));

                // Get item data
                var data = suggestion.data;
                var itemCode = data.itemcode;
                var itemMinOrder = data.minorder || 1;
                var itemMultiple = data.multiply || 1;
                var customerMinOrder =
                    typeof data.customer_minorder === "number"
                        ? data.customer_minorder
                        : null;
                var customerItemCode = data.customer_item_code;
                var itemName = data.itemname;
                var itemPrice = data.price;
                var localStock =
                    data.localstock === null ? "N/A" : data.localstock;
                var nationalStock =
                    data.nationalstock === null ? "N/A" : data.nationalstock;

                // Add item to cart when clicked
                orderPadCartAddItem(
                    itemCode,
                    customerItemCode,
                    itemName,
                    itemMinOrder,
                    itemMultiple,
                    itemPrice,
                    localStock,
                    nationalStock,
                    1,
                    customerMinOrder
                );

                // Clear search field
                $orderPadSearchField.val("");
            },
        };

        // Autocomplete for order pad search by fairview part no
        autocompleteOptions.serviceUrl =
            root + "/api/item/search-by-fairview-part-no.php";
        $orderPadSearchField.autocomplete(autocompleteOptions);

        // Autocomplete for order pad search by customer part no
        autocompleteOptions.serviceUrl =
            root + "/api/item/search-by-customer-part-no.php";
        $orderPadSearchFieldByCustomerPartNo.autocomplete(autocompleteOptions);

        // Order pad cart elements
        $orderPadItemsTable = $("#orderpad-items-in-cart-list");

        // Shipping address dropdown
        $shippingAddressDropdown = $("#shipping-address");
        var $shippingAddressValue = $("#shipping-address-value");

        // Get shipping addresses from API
        $.ajax({
            url: root + "/api/customer/address.php",
            type: "POST",
        }).done(function (json) {
            // Populate dropdown
            $(json.data).map(function (i, el) {
                /** @type {any} */
                var addressValues = el;

                var fullAddress =
                    addressValues.street +
                    "<br>" +
                    addressValues.city +
                    " " +
                    addressValues.state +
                    " " +
                    addressValues.zipcode +
                    ", " +
                    addressValues.country;
                var $option = $(
                    '<option value="' +
                        addressValues.address_id +
                        '">' +
                        addressValues.address +
                        "</option>"
                ).data("full-address", fullAddress);
                $shippingAddressDropdown.append($option);
            });

            // Check if there are any addresses, select first entry if there are
            if ($shippingAddressDropdown.find("option").length > 0) {
                var $firstOption =
                    $shippingAddressDropdown.find("option:first");
                $firstOption.prop("selected", true);
                $shippingAddressValue.html($firstOption.data("full-address"));
                var infoFieldShippingId = $firstOption.val();
            } else {
                $shippingAddressDropdown.append(
                    '<option value="0">You have no shipping addresses under your account.</option>'
                );
            }

            // Save shipping address to database
            $.ajax({
                url: root + "/api/cart/add.php",
                type: "POST",
                data: "address_id=" + $shippingAddressDropdown.val(),
            });
        });

        // Add dropdown change event
        $shippingAddressDropdown.on("change", function (e) {
            // Update address below
            var address = $shippingAddressDropdown
                .find("option:selected")
                .data("full-address");
            $shippingAddressValue.html(address);

            // Save new shipping id to the cart
            $.ajax({
                url: root + "/api/cart/add.php",
                type: "POST",
                data: "address_id=" + $shippingAddressDropdown.val(),
            });
        });

        // Get info fields
        $deliveryMethodRadios = $("#order-shipping-type input");
        $infoFieldPoNum = $("#po-num");
        $infoFieldShipViaAcctNo = $("#ship-via-acct-no");
        $infoFieldConfirmationEmail = $("#send-to-email-address");
        $infoFieldOrderNote = $("#special-instructions");

        // Radio changes
        $deliveryMethodRadios.on("change", function (e) {
            $.ajax({
                url: root + "/api/cart/add.php",
                type: "POST",
                data:
                    "shipping=" +
                    $deliveryMethodRadios.filter(":checked").val(),
            });
        });

        // Po num change
        $infoFieldPoNum.on("change", function (e) {
            $.ajax({
                url: root + "/api/cart/add.php",
                type: "POST",
                data: "po=" + $infoFieldPoNum.val(),
            });
        });

        // Order notes change
        $infoFieldOrderNote.on("change", function (e) {
            $.ajax({
                url: root + "/api/cart/add.php",
                type: "POST",
                data: "notes=" + $infoFieldOrderNote.val(),
            });
        });

        // Submit order when place an order button is clicked
        var $orderPadPlaceOrderButton = $("#order-button");
        $orderPadPlaceOrderButton.on("click", function (e) {
            // Check if there are items in cart
            if (itemsInCart.length > 0) {
                // Check if cart total is equal to or larger than min order for the customer
                const totalCartPrice = orderPadCartTotalPrice();

                if (totalCartPrice >= (minOrderPrice || 0)) {
                    var $minPriceNotice = $("#order-min-price-notice");
                    if ($minPriceNotice) {
                        $minPriceNotice.fadeOut(300);
                    }

                    // PO number field value
                    var infoFieldPoNum = $infoFieldPoNum.val();

                    // Check if PO number field is filled
                    if (infoFieldPoNum.trim().length > 0) {
                        var infoFieldShipViaAcctNo =
                            $infoFieldShipViaAcctNo.val();

                        // Check if PO number field is filled
                        if (infoFieldShipViaAcctNo.trim().length > 0) {
                            // Define post data
                            var savePostData = {};

                            var infoFieldConfirmationEmail =
                                $infoFieldConfirmationEmail.val();

                            // Check if email is defined
                            if (
                                infoFieldConfirmationEmail.trim().length > 0 &&
                                isValidEmailAddress(infoFieldConfirmationEmail)
                            ) {
                                // Add to post data
                                savePostData["email"] =
                                    infoFieldConfirmationEmail;

                                var $orderEmailSaveAsDefault = $(
                                    "#order-confirmation-email-as-default"
                                );
                                if ($orderEmailSaveAsDefault) {
                                    // Check if email save as default is checked
                                    if (
                                        $orderEmailSaveAsDefault.prop(
                                            "checked"
                                        ) === true
                                    ) {
                                        // Append to post
                                        savePostData["save-email"] = 1;
                                    }
                                }

                                // Change button's label, class and disable it to prevent double click
                                var textPlacing =
                                    $orderPadPlaceOrderButton.data("placing");
                                $orderPadPlaceOrderButton.text(textPlacing);
                                $orderPadPlaceOrderButton.prop(
                                    "class",
                                    "button button-secondary"
                                );
                                $orderPadPlaceOrderButton.prop(
                                    "disabled",
                                    "disabled"
                                );

                                // Clear errors if there are any
                                $infoFieldPoNum.removeClass("alert");
                                $infoFieldShipViaAcctNo.removeClass("alert");
                                $infoFieldConfirmationEmail.removeClass(
                                    "alert"
                                );
                                $orderPadPlaceOrderButton.removeClass(
                                    "button-cancel"
                                );

                                // Check if ship via / acct no is defined
                                var $orderPadShipViaAcctNo =
                                    $("#ship-via-acct-no");
                                var $orderPadShipViaAcctNoSaveAsDefault = $(
                                    "#ship-via-acct-no-save-as-default"
                                );
                                if (
                                    $orderPadShipViaAcctNo &&
                                    $orderPadShipViaAcctNoSaveAsDefault
                                ) {
                                    // Check if ship via value exist
                                    if (
                                        $orderPadShipViaAcctNo.val().length > 0
                                    ) {
                                        // Append to post
                                        savePostData["shipvia"] =
                                            $orderPadShipViaAcctNo.val();

                                        // Check if ship via save as default is checked
                                        if (
                                            $orderPadShipViaAcctNoSaveAsDefault.prop(
                                                "checked"
                                            ) === true
                                        ) {
                                            // Append to post
                                            savePostData["save-shipvia"] = 1;
                                        }
                                    }
                                }

                                // Submit order via ajax
                                $.ajax({
                                    url: root + "/api/order/save.php",
                                    data: savePostData,
                                    type: "POST",
                                }).done(function (json) {
                                    // On success change button's class to `button button-success` and label to `Order Placed`
                                    var textSuccess =
                                        $orderPadPlaceOrderButton.data(
                                            "success"
                                        );
                                    $orderPadPlaceOrderButton.text(textSuccess);
                                    $orderPadPlaceOrderButton.prop(
                                        "class",
                                        "button button-success"
                                    );

                                    // Clear everything after delay
                                    setTimeout(function () {
                                        $orderPadPlaceOrderButton.prop(
                                            "disabled",
                                            false
                                        );
                                        $orderPadPlaceOrderButton.prop(
                                            "class",
                                            "button button-primary"
                                        );
                                        // get text from data attrib
                                        var textPlace =
                                            $orderPadPlaceOrderButton.data(
                                                "place"
                                            );
                                        $orderPadPlaceOrderButton.text(
                                            textPlace
                                        );
                                        orderPadCartCleanup();
                                    }, 1024 * 5);
                                });
                            } else {
                                $infoFieldPoNum.removeClass("alert");
                                $infoFieldShipViaAcctNo.removeClass("alert");
                                $infoFieldConfirmationEmail.addClass("alert");
                                $orderPadPlaceOrderButton.text(
                                    "Confirmation Email is required"
                                );
                                $orderPadPlaceOrderButton.addClass(
                                    "button-cancel"
                                );
                                setTimeout(function () {
                                    $orderPadPlaceOrderButton.text(
                                        "Place an Order"
                                    );
                                    $orderPadPlaceOrderButton.removeClass(
                                        "button-cancel"
                                    );
                                }, 1024 * 5);
                            }
                        } else {
                            $infoFieldPoNum.removeClass("alert");
                            $infoFieldShipViaAcctNo.addClass("alert");
                            $orderPadPlaceOrderButton.text(
                                "Ship Via / Acct No. is required"
                            );
                            $orderPadPlaceOrderButton.addClass("button-cancel");
                            setTimeout(function () {
                                $orderPadPlaceOrderButton.text(
                                    "Place an Order"
                                );
                                $orderPadPlaceOrderButton.removeClass(
                                    "button-cancel"
                                );
                            }, 1024 * 5);
                        }
                    } else {
                        $infoFieldPoNum.addClass("alert");
                        $orderPadPlaceOrderButton.text("PO number is required");
                        $orderPadPlaceOrderButton.addClass("button-cancel");
                        setTimeout(function () {
                            $orderPadPlaceOrderButton.text("Place an Order");
                            $orderPadPlaceOrderButton.removeClass(
                                "button-cancel"
                            );
                        }, 1024 * 5);
                    }
                } else {
                    var $minPriceNotice = $("#order-min-price-notice");
                    if ($minPriceNotice) {
                        var minPriceNoticeText = $minPriceNotice.text();
                        $minPriceNotice.text(
                            minPriceNoticeText.replace(
                                "$XXX",
                                "$" + (minOrderPrice || 0)
                            )
                        );
                        $minPriceNotice.fadeIn(300);
                    }

                    $orderPadPlaceOrderButton.text("Increase cart total");
                    $orderPadPlaceOrderButton.addClass("button-cancel");
                    setTimeout(function () {
                        $orderPadPlaceOrderButton.text("Place an Order");
                        $orderPadPlaceOrderButton.removeClass("button-cancel");
                    }, 1024 * 3);
                }
            } else {
                $orderPadPlaceOrderButton.text("Add items to place an order");
                $orderPadPlaceOrderButton.addClass("button-cancel");
                setTimeout(function () {
                    $orderPadPlaceOrderButton.text("Place an Order");
                    $orderPadPlaceOrderButton.removeClass("button-cancel");
                }, 1024 * 5);
            }

            // Prevent default
            e.preventDefault();
        });

        // Pull items from cart and populate item rows
        orderPadCartGetItems();
    }
}

function handleHelpRow() {
    if (
        $("table.items tr").not(".fadeOutDown, .dummy-row, #order-summary")
            .length === 1 &&
        $(".dummy-row").length === 0
    ) {
        var text = $("#order-table").data("helptext");
        var dummyRow = $(
            '<tr class="dummy-row text-center"><td colspan="9"></td> </tr>'
        );
        dummyRow.find("td").html(text);
        dummyRow.addClass("fadeInUp animated");
        $("table.items .basic-body").prepend(dummyRow);
    } else if (
        $("table.items tr").not(".fadeOutDown, .dummy-row, #order-summary")
            .length > 1 &&
        $(".dummy-row").length > 0
    ) {
        $(".dummy-row").addClass("fadeOutDown animated");
        setTimeout(function () {
            $(".dummy-row").remove();
        }, 1000);
    }
}

function isValidEmailAddress(emailAddress) {
    var pattern =
        /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
    return pattern.test(emailAddress);
}

/**
 * Number function that parses it as currency
 *
 * @param {boolean} wrap - false by default; if true, wraps output in html paragraph
 * @param {string} currency - by default "USD"; currency code
 * @param {string} zeroIsString - provided text will be displayed if supplied number is equal to 0
 * @returns {string} HTML string
 */
Number.prototype.parseAsCurrency = function (wrap, currency, zeroIsString) {
    // Get number
    var val = +this;

    // Determine wrap return
    wrap = typeof wrap === "undefined" ? false : wrap;

    // Check if zero should be a string
    if (
        val === 0 &&
        typeof zeroIsString !== "undefined" &&
        zeroIsString !== ""
    ) {
        // Return the string
        if (wrap === true) {
            return '<p class="price">' + zeroIsString + "</p>";
        } else {
            return zeroIsString;
        }
    } else {
        // Get currency mark and its position
        currency = typeof currency === "undefined" ? "USD" : currency;
        var currencyMarkBefore = true;
        var currencyMark = "$";

        // Get currency formatting
        // @ts-ignore
        var endNumber = parseFloat(val).toFixed(4);
        var splitEndNumber = endNumber.toString().split(".");

        // Prepare final string
        var output = "";
        output +=
            currencyMarkBefore === true
                ? "<sub>" + currencyMark + "</sub>"
                : "";
        output += "<strong>" + splitEndNumber[0] + "</strong>";
        output += ".";
        output += "<sub>" + splitEndNumber[1] + "</sub>";
        output +=
            // @ts-ignore
            currencyMarkBefore === false
                ? "<sub>" + currencyMark + "</sub>"
                : "";

        // Return wrapped or not output
        if (wrap === true) {
            return '<p class="price">' + output + "</p>";
        } else {
            return output;
        }
    }
};

/**
 * Allow deferring of event
 */
var waitForFinalEvent = (function () {
    var timers = {};
    return function (callback, ms, uniqueId) {
        if (!uniqueId) {
            uniqueId = "Don't call this twice without a uniqueId";
        }
        if (timers[uniqueId]) {
            clearTimeout(timers[uniqueId]);
        }
        timers[uniqueId] = setTimeout(callback, ms);
    };
})();
